import keymirror from "../utils/keymirror";

export const UserSetupConstants = keymirror(
    {
        UPDATE_USER_SETUP_PROPERTY: null,
        COMPLETE_USER_SETUP: null,
        COMPLETE_USER_SETUP_SUCCESS: null,
        COMPLETE_USER_SETUP_FAILURE: null
    },
    "user-settings"
);



// WEBPACK FOOTER //
// ./src/constants/userSetup.constants.js